var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"1rem 3rem 4rem 3rem","text-align":"center"}},[_c('div',{staticStyle:{"background-color":"crimson","color":"#ffffff","padding":"10px 30px","font-weight":"lighter"},on:{"click":_vm.click}},[_vm._v("\n        "+_vm._s(_vm.value)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }